import { render, staticRenderFns } from "./NewUpdates.vue?vue&type=template&id=45685e3a&scoped=true"
import script from "./NewUpdates.vue?vue&type=script&lang=js"
export * from "./NewUpdates.vue?vue&type=script&lang=js"
import style0 from "./NewUpdates.vue?vue&type=style&index=0&id=45685e3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45685e3a",
  null
  
)

export default component.exports